module.exports = __webpack_public_path__ + "static/c2-e5dcb1cecac5281fcb6db19d731fecf2.jpg";